// -----------------------------------------------------------------------------
// Hilfreiche Funktionen
// -----------------------------------------------------------------------------

/**
 * Holt ein JSON-Objekt aus dem HTML-Code
 *
 * @param selector
 */
const getJsonFromHtml = (selector) => {
  const data = document.querySelector(selector);

  if (data === null) {
    console.log('JSON fehlt');
    return {};
  }

  return JSON.parse(data.textContent);
};

/**
 * Wandelt String in Boolean um
 *
 * @param input
 * @returns {boolean}
 */
const strToBool = (input) => {
  if (typeof input === 'undefined') {
    return false;
  }

  return (input.toLowerCase() === 'true');
};

export {
  getJsonFromHtml,
  strToBool
};
